import { EServiceId } from '../types';
import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const CHANGE_PROMOTION_SERVICE = 'PUBLISH_TERMS :: CHANGE_PROMOTION_SERVICE';

export type TChangePromotionServiceAction = IReduxAction<typeof CHANGE_PROMOTION_SERVICE, EServiceId>;

export const changePromotionService = actionGenerator<typeof CHANGE_PROMOTION_SERVICE, EServiceId>(
  CHANGE_PROMOTION_SERVICE,
);
